@if (whatsNewObs | async; as whatsNewElement) {
    @let videoSource = getVideoSource(whatsNewElement);
    <sew-headline level="4">{{ whatsNewElement.headline }}</sew-headline>
    <sew-richtext><p [innerHTML]="whatsNewElement.description | replaceDoubleLinebreak"></p></sew-richtext>
    <sew-accordion size="xs">
        @for (item of whatsNewElement.content; track item) {
            <sew-accordion-item [headline]="item.headline">
                <p>
                    {{ item.content | replaceDoubleLinebreak }}
                </p>
                @if (item.image) {
                    <img [src]="item.image.src" [alt]="item.image.alt" [title]="item.image.title" />
                }
            </sew-accordion-item>
        }
    </sew-accordion>

    @if (videoSource) {
        <sew-video
            [src]="videoSource"
            class="whats-new-video"
            aspectRatio="16/9"
            controls="true"
            allowFullScreen="true"
        ></sew-video>
    }
}
